import { Link } from "react-router-dom";
import { useT } from "../i18n/index.js";

const s = {
  actions: {
    display: "flex",
    flexWrap: "wrap" as const,
    gap: "var(--space-sm)",
    justifyContent: "center",
    marginTop: "var(--space-lg)",
  },
  brand: {
    color: "var(--brand)",
    fontSize: "var(--text-sm)",
    fontWeight: 800,
    letterSpacing: "0.08em",
    margin: "0 0 var(--space-sm)",
    textTransform: "uppercase" as const,
  },
  body: {
    color: "var(--text-mid)",
    fontSize: "var(--text-sm)",
    margin: "var(--space-sm) auto 0",
    maxWidth: "28ch",
    textAlign: "center" as const,
  },
  link: {
    alignItems: "center",
    background: "var(--brand)",
    borderRadius: "var(--radius-md)",
    color: "#fff",
    display: "inline-flex",
    fontSize: "var(--text-sm)",
    fontWeight: 800,
    justifyContent: "center",
    minHeight: "48px",
    padding: "0.75rem 1rem",
    textDecoration: "none",
  },
  secondaryLink: {
    alignItems: "center",
    background: "var(--surface)",
    border: "1.5px solid var(--border)",
    borderRadius: "var(--radius-md)",
    color: "var(--text)",
    display: "inline-flex",
    fontSize: "var(--text-sm)",
    fontWeight: 700,
    justifyContent: "center",
    minHeight: "48px",
    padding: "0.75rem 1rem",
    textDecoration: "none",
  },
  title: {
    color: "var(--text)",
    fontSize: "var(--text-xl)",
    fontWeight: 800,
    lineHeight: 1.15,
    margin: 0,
    textAlign: "center" as const,
  },
};

export function NotFoundPage() {
  const t = useT();
  return (
    <main className="page-center">
      <section className="card" aria-labelledby="not-found-title">
        <p style={s.brand}>HootApp</p>
        <h1 id="not-found-title" style={s.title}>{t("error.notFoundTitle")}</h1>
        <p style={s.body}>
          {t("error.notFoundDetail")}
        </p>
        <div style={s.actions}>
          <Link to="/" style={s.link}>{t("error.notFoundHome")}</Link>
          <Link to="/join" style={s.secondaryLink}>{t("notFound.joinGame")}</Link>
        </div>
      </section>
    </main>
  );
}
